module.exports = __webpack_public_path__ + "img/app.0d6c2653.svg";